import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { UserIcon, MailIcon, PhoneIcon, MapPinIcon, CameraIcon } from 'lucide-react';
import { TopBar } from '../components/TopBar';
interface EditProfileProps {
  navigate: (screen: string) => void;
}
export function EditProfile({
  navigate
}: EditProfileProps) {
  const [isSaving, setIsSaving] = useState(false);
  const handleSave = () => {
    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      navigate('profile');
    }, 1000);
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="flex-1 overflow-y-auto pb-safe bg-slate-50" data-id="element-1638">
      <TopBar title="Edit Profile" showBack onBack={() => navigate('profile')} data-id="element-1639" />

      <div className="px-5 pt-6 pb-8" data-id="element-1640">
        {/* Avatar Upload */}
        <div className="flex flex-col items-center mb-8" data-id="element-1641">
          <div className="relative" data-id="element-1642">
            <div className="w-24 h-24 rounded-full bg-[#0D3B3B] text-white flex items-center justify-center text-3xl font-bold shadow-lg border-4 border-white" data-id="element-1643">
              AO
            </div>
            <button className="absolute bottom-0 right-0 w-8 h-8 bg-[#FFD700] rounded-full flex items-center justify-center shadow-md border-2 border-white text-[#0D3B3B]" data-id="element-1644">
              <CameraIcon className="w-4 h-4" data-id="element-1645" />
            </button>
          </div>
        </div>

        {/* Form */}
        <div className="space-y-4 mb-8" data-id="element-1646">
          <div className="space-y-1.5" data-id="element-1647">
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1648">
              Full Name
            </label>
            <div className="relative flex items-center" data-id="element-1649">
              <div className="absolute left-4 text-gray-400" data-id="element-1650">
                <UserIcon className="w-5 h-5" data-id="element-1651" />
              </div>
              <input type="text" defaultValue="Adaeze Okonkwo" className="w-full bg-white border border-gray-200 rounded-2xl py-3.5 pl-12 pr-4 text-sm font-medium text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D] transition-all" data-id="element-1652" />
            </div>
          </div>

          <div className="space-y-1.5" data-id="element-1653">
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1654">
              Email
            </label>
            <div className="relative flex items-center" data-id="element-1655">
              <div className="absolute left-4 text-gray-400" data-id="element-1656">
                <MailIcon className="w-5 h-5" data-id="element-1657" />
              </div>
              <input type="email" defaultValue="adaeze@email.com" className="w-full bg-white border border-gray-200 rounded-2xl py-3.5 pl-12 pr-4 text-sm font-medium text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D] transition-all" data-id="element-1658" />
            </div>
          </div>

          <div className="space-y-1.5" data-id="element-1659">
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1660">
              Phone
            </label>
            <div className="relative flex items-center" data-id="element-1661">
              <div className="absolute left-4 text-gray-400" data-id="element-1662">
                <PhoneIcon className="w-5 h-5" data-id="element-1663" />
              </div>
              <input type="tel" defaultValue="+234 801 234 5678" className="w-full bg-white border border-gray-200 rounded-2xl py-3.5 pl-12 pr-4 text-sm font-medium text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D] transition-all" data-id="element-1664" />
            </div>
          </div>

          <div className="space-y-1.5" data-id="element-1665">
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1666">
              Address
            </label>
            <div className="relative flex items-center" data-id="element-1667">
              <div className="absolute left-4 text-gray-400" data-id="element-1668">
                <MapPinIcon className="w-5 h-5" data-id="element-1669" />
              </div>
              <input type="text" defaultValue="12 Admiralty Way, Lekki Phase 1, Lagos" className="w-full bg-white border border-gray-200 rounded-2xl py-3.5 pl-12 pr-4 text-sm font-medium text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D] transition-all" data-id="element-1670" />
            </div>
          </div>
        </div>

        <button onClick={handleSave} disabled={isSaving} className="w-full bg-[#0D3B3B] hover:bg-[#092D2D] text-[#FFD700] font-bold py-4 rounded-xl transition-all shadow-lg shadow-[#0D3B3B]/20 active:scale-95 text-lg flex justify-center items-center" data-id="element-1671">
          {isSaving ? <div className="w-6 h-6 border-2 border-[#FFD700]/30 border-t-[#FFD700] rounded-full animate-spin" data-id="element-1672" /> : 'Save Changes'}
        </button>
      </div>
    </motion.div>;
}